<app-header></app-header>

<div class="api-error-notify-block" *ngIf="apiError.length">
    <div class="epi-error">{{apiError[0].errorMessage}}</div>
</div>

<router-outlet></router-outlet>